import type { SVGProps } from "react";

/**
 * Line-style email glyph used across Chats, settings/connections,
 * channel-connect wizards, and customer details. Centralized so stroke/size/color stay consistent.
 */
const EmailIcon = ({
  className,
  strokeWidth = 1.5,
  ...props
}: SVGProps<SVGSVGElement> & { className?: string }) => (
  <svg
    data-channel-icon="email"
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
    {...props}
  >
    <rect x="2" y="4" width="20" height="16" rx="2" />
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
  </svg>
);

export default EmailIcon;
